import { ImageLoaderCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss';

export class ToneMobileCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '140px',
            borderRadius: "25px 0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonemobilecardimageloadercss.tsx